import {
    AfterViewChecked,
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    Input,
    OnInit,
} from '@angular/core'
import { HomeUrlService } from 'framework/home-url/home-url.service'

function offset(el) {
    const rect = el.getBoundingClientRect()
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

@Component({
    selector: 'mg-checkout-sticky-nav',
    templateUrl: './checkout-sticky-nav.component.html',
    styleUrls: ['./checkout-sticky-nav.component.scss'],
})
export class CheckoutStickyNavComponent implements AfterViewChecked, AfterViewInit, OnInit {
    @Input() modelName: string
    @Input() titleVariant: 'default' | 'confirm' | 'sales-advisor'

    scrollPosition: number = 0
    navPosition: number = 0
    isSticky: boolean = false
    homeUrl: string = '/'

    constructor(
        private hostElement: ElementRef,
        private cdRef: ChangeDetectorRef,
        private homeUrlService: HomeUrlService
    ) {}

    ngOnInit(): void {
        this.homeUrl = this.homeUrlService.getHomeUrl()
    }

    ngAfterViewInit() {
        this.syncScrollPosition()
    }

    ngAfterViewChecked() {
        this.syncNavPosition()
        this.determineIsSticky()
        this.cdRef.detectChanges()
    }

    determineIsSticky() {
        this.isSticky = this.scrollPosition > this.navPosition
    }

    syncNavPosition() {
        this.navPosition = offset(this.hostElement.nativeElement).top
    }

    syncScrollPosition() {
        this.scrollPosition = window.pageYOffset
    }

    @HostListener('window:resize')
    private onResize(): void {
        this.syncNavPosition()
        this.onScroll()
    }

    @HostListener('window:scroll')
    private onScroll(): void {
        this.syncScrollPosition()
        this.determineIsSticky()
    }
}
